import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12" }
const _hoisted_2 = {
  class: "card bg-white mb-3",
  style: {"border-radius":"10px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { id: "roles-grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BButtonGroup = _resolveComponent("BButtonGroup")!
  const _component_BPagination = _resolveComponent("BPagination")!
  const _component_BButtonToolbar = _resolveComponent("BButtonToolbar")!
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "mt-2" }, "System Roles", -1)),
          _createVNode(_component_BButtonToolbar, { class: "mb-2 pt-2 border-light border-top" }, {
            default: _withCtx(() => [
              _createVNode(_component_BButtonGroup, null, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_BButton, {
                    variant: "outline-primary",
                    size: "sm",
                    onClick: _ctx.onAddNew,
                    class: "custom-button"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: "plus" }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("systemRolesGrid.addNew")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_permission, 'AbpIdentity.Roles.Create']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_BButton, {
                    variant: "light",
                    size: "sm",
                    onClick: _ctx.onDelete,
                    class: "ml-2",
                    disabled: _ctx.datas.selected.length === 0,
                    style: {"background-color":"#e9ecef"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("systemRolesGrid.delete")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])), [
                    [_directive_permission, 'AbpIdentity.Roles.Delete']
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_BPagination, {
                id: "grid-pagination",
                modelValue: _ctx.pagination.page,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination.page) = $event)),
                  _ctx.onPaginationChange
                ],
                "total-rows": _ctx.datas.total,
                "per-page": _ctx.pagination.maxResultCount,
                "aria-controls": "table",
                class: "ml-auto"
              }, null, 8, ["modelValue", "total-rows", "per-page", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataTable, {
            id: "table",
            sortBy: _ctx.sort.sortBy,
            "onUpdate:sortBy": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sort.sortBy) = $event)),
            busy: _ctx.isBusy,
            fields: _ctx.fields,
            items: _ctx.datas.items,
            "no-local-sorting": true,
            "sort-desc": _ctx.sort.sortDesc,
            "onUpdate:sortDesc": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sort.sortDesc) = $event)),
            "sort-descModifiers": { sync: true },
            fixed: "",
            hover: "",
            "select-mode": "single",
            selectable: "",
            onRowSelected: _ctx.onRowSelected,
            onSortChanged: _ctx.onSortChanged,
            linkFields: { name: '/systemRoles/edit/' }
          }, {
            "table-busy": _withCtx(() => [
              _createVNode(_component_GridLoading)
            ]),
            "cell(name)": _withCtx((data) => [
              _createVNode(_component_router_link, {
                to: '/systemRoles/edit/' + data.item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(data.item.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["sortBy", "busy", "fields", "items", "sort-desc", "onRowSelected", "onSortChanged"])
        ])
      ])
    ])
  ]))
}